
const prodMode = process.env.NODE_ENV === 'production';

export default {
  apiHost: process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST : 'http://localhost:5000',
  apiSchedule:'https://apischedule.cdp.dental',
  apiMy:'https://myapi.cdp.dental',
  goApi : prodMode ? 'https://api.cdp.dental' : 'http://localhost:8080'
};
